import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";

/**
 * Runs a tracking call in a way that cannot break the interaction it is attached to.
 *
 * Filter and search tracking runs as the first statement of a submit handler, before the navigation itself and
 * with nothing above it that could catch - SRV-583 was exactly that: a throw inside the amplitude payload build
 * silently swallowed every "apply filters" click. The error is reported to Bugsnag instead, the caller continues.
 */
export const runTrackingSafely = (task: () => void, errorInfo: string, errorData?: unknown): void => {
    try {
        task();
    } catch (error) {
        notifyBugsnag(error, errorInfo, errorData);
    }
};
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";

/**
 * Runs a tracking call in a way that cannot break the interaction it is attached to.
 *
 * Filter and search tracking runs as the first statement of a submit handler, before the navigation itself and
 * with nothing above it that could catch - SRV-583 was exactly that: a throw inside the amplitude payload build
 * silently swallowed every "apply filters" click. The error is reported to Bugsnag instead, the caller continues.
 */
export const runTrackingSafely = (task: () => void, errorInfo: string, errorData?: unknown): void => {
    try {
        task();
    } catch (error) {
        notifyBugsnag(error, errorInfo, errorData);
    }
};
